import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox", "content", "input"]

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled = this.checkboxTarget.checked

    this.contentTarget.classList.toggle("is-hidden", !enabled)
    this.contentTarget.setAttribute("aria-hidden", (!enabled).toString())

    this.inputTargets.forEach((input) => {
      input.disabled = !enabled
    })
  }
}
